/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs */

const en_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All Events From Current`)
};

const fr_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner tous les evenements a partir de l'actuel`)
};

const de_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Ereignisse aus der aktuellen Liste auswählen`)
};

const it_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutti gli eventi da quelli correnti`)
};

const ru_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать все события из текущего списка`)
};

const es_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todos los eventos actuales`)
};

const zh_cn2_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从当前事件中选择所有事件`)
};

const ja_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のすべてのイベントを選択`)
};

const hi_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान में सभी इवेंट चुनें`)
};

const pt_pt2_shortcut_keys_name_select_all_events_from_current = /** @type {(inputs: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione todos os eventos da lista atual.`)
};

/**
* | output |
* | --- |
* | "Select All Events From Current" |
*
* @param {Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_select_all_events_from_current = /** @type {((inputs?: Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Select_All_Events_From_CurrentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "de") return de_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "it") return it_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "es") return es_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_select_all_events_from_current(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_select_all_events_from_current(inputs)
	return en_shortcut_keys_name_select_all_events_from_current(inputs)
});